module.exports = __webpack_public_path__ + "static/media/excel.679c03a5.svg";